import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggleText", "toggleIcon"]

  connect() {
    console.log("Collapsible controller connected")
  }

  toggle() {
    console.log("Toggle clicked")
    const content = this.contentTarget
    const text = this.toggleTextTarget
    const icon = this.toggleIconTarget

    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden")
      text.textContent = "発注書を隠す"
      icon.classList.add("rotate-180")
    } else {
      content.classList.add("hidden")
      text.textContent = "発注書を表示"
      icon.classList.remove("rotate-180")
    }
  }
}